export const AUDIT_PAGE_SIZE: number = 25;

export const AUDIT_PER_PAGE_OPTIONS: readonly number[] = [10, 25, 50, 100];

export const FIRST_PAGE: number = 1;

export interface AuditFilters {
  actor_email: string;
  action: string;
  entity_name: string;
  entity_id: string;
  start: string;
  end: string;
}

export const EMPTY_AUDIT_FILTERS: AuditFilters = {
  actor_email: "",
  action: "",
  entity_name: "",
  entity_id: "",
  start: "",
  end: "",
};

export const AUDIT_ACTION_OPTIONS = [
  { value: "", label: "Todas as ações" },
  { value: "CREATE", label: "Cadastro" },
  { value: "UPDATE", label: "Edição" },
  { value: "DELETE", label: "Exclusão" },
  { value: "INACTIVE", label: "Inativação" },
  { value: "REACTIVE", label: "Reativação" },
  { value: "APPROVE", label: "Aprovação" },
  { value: "REJECT", label: "Recusa" },
  { value: "REVERT", label: "Reversão" },
  { value: "EXPORT", label: "Exportação" },
  { value: "SEND_EMAIL", label: "Envio" },
  { value: "RESEND_EMAIL", label: "Reenvio" },
] as const;

export const AUDIT_ENTITY_OPTIONS = [
  { value: "", label: "Todas as entidades" },
  { value: "SHIPPING_RECIPIENT", label: "Destinatário" },
  { value: "PAYROLL_VOUCHER", label: "Vale" },
  { value: "PAYROLL_EXPORT", label: "Planilha" },
  { value: "SHIPPING", label: "Despacho" },
  { value: "DIVERGENCE", label: "Divergência" },
] as const;
